
import jwt_decode from "jwt-decode";
import { AUTH, LOGOUT, REPOPULATE, UPDATE_PROFILE} from '../constants/actionTypes';
import * as api from '../api';

export const signup = (formData, cb) => async (dispatch) =>  {

    let error = null;
    let res = null; 

    try {

        //signup
        const {data} = await api.signup(formData);

        dispatch({
            type: AUTH,
            data
        });



        res = data; 

    } catch (err) {
        console.warn(err)
        error = err; 
    }

    if(typeof cb === 'function'){
        cb(error, res);
    }
    
}

export const login = (formData, cb) => async (dispatch) =>  {


    let error = null;
    let res = null; 

    try {

        //login
        const {data} = await api.login(formData);

        dispatch({
            type: AUTH,
            data
        });


        //navigate to home page
        res = data; 

    } catch (err) {
        console.warn(err)

        error = err; 
    }


    if(typeof cb === 'function'){
        cb(error, res);
    }

}

export const deleteAccount = (id, navigate) => async (dispatch) =>  {

    //This is where you sanitize your data etc

    try {

        //login
        const {data} = await api.deleteAccount(id);

        dispatch({
            type: LOGOUT,
            data
        });


        //navigate to home page
        navigate('/');

    } catch (err) {
        console.warn(err)
    }


}

export const editProfile = (inputData, navigate, url) => async (dispatch) => {

    try {

        console.log('Input data: ', inputData);

        //sort input data -- create multipart form 
        const formData = new FormData(); 

        for(const property in inputData){

            formData.append(property, inputData[property]);

        }

        console.log('Form data: ', formData);

        //make request here
        const { data } = await  api.editProfile(formData);

        navigate(url || '/');

        console.log('edit profile returned data: ', data);

        dispatch({
            type: UPDATE_PROFILE,
            data
        });

        
    } catch (error) {

        console.warn(error);
        
    }
}


export const editProfileInfo = (inputData, navigate, url) => async (dispatch) => {

    try {

        console.log('Input data: ', inputData);

        //sort input data -- create multipart form 
        const formData = {}; 

        for(const property in inputData){

            console.log('property: ', property);

            if(property === 'profileImage'){
                continue;
            }

            formData[property] = inputData[property];

        }

        console.log('Form data: ', formData);

        //make request here
        const { data } = await  api.editProfileInfo(formData);

        navigate(url || '/');

        console.log('edit profile returned data: ', data);

        dispatch({
            type: UPDATE_PROFILE,
            data
        });

        
    } catch (error) {

        console.warn(error);
        
    }
}


export const editProfileImage = (inputData, navigate, url) => async (dispatch) => {

    try {

        console.log('Input data: ', inputData);

        //sort input data -- create multipart form 
        const formData = new FormData(); 

        for(const property in inputData){

            formData.append(property, inputData[property]);

        }

        console.log('Form data: ', formData);

        //make request here
        const { data } = await  api.editProfileImage(formData);

        navigate(url || '/');

        console.log('edit profile returned data: ', data);

        dispatch({
            type: UPDATE_PROFILE,
            data
        });

        
    } catch (error) {

        console.warn(error);
        
    }
}

export const editProfileBGImage = (inputData, navigate, url) => async (dispatch) => {

    try {

        console.log('Input data: ', inputData);

        //sort input data -- create multipart form 
        const formData = new FormData(); 

        for(const property in inputData){

            if(property === 'avColors'){

                inputData[property] = JSON.stringify(inputData[property]);
            }

            formData.append(property, inputData[property]);

        }

        console.log('Form data: ', formData);

        //make request here
        const { data } = await  api.editProfileBGImage(formData);

        if(navigate){
            navigate(url || '/');
        }

        console.log('edit profile returned data: ', data);

        dispatch({
            type: UPDATE_PROFILE,
            data
        });

        
    } catch (error) {

        console.warn(error);
        
    }
}

export const googleLogin = (res) => {


    console.log('res: ', res);
    let actionObject = {};

    try {
        const token = res?.credential; 
        const result = jwt_decode(token);
        actionObject = {
            type: AUTH,
            data: {
                token,
                result 
            }
        };

    }catch(err){
        console.warn(err);
    }
    

    return actionObject;

}

export const logout = () => {

    console.log('being logged out');

    return {
        type: LOGOUT
    };
}

export const rePopulate = (profile) => async (dispatch) =>  {

    //This is where you sanitize your data etc

    try {

        dispatch({
            type: REPOPULATE,
            data: profile
        });

    } catch (err) {
        console.warn(err)
    }


}